// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AppBar layout. Visual tokens (.appbar, .appbar__*) live in components.css. */
.appbar__rightspacer {
  width: 40px;
  flex: 0 0 40px;
}
`, "",{"version":3,"sources":["webpack://./src/screens/components/appBar.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,WAAW;EACX,cAAc;AAChB","sourcesContent":["/* AppBar layout. Visual tokens (.appbar, .appbar__*) live in components.css. */\n.appbar__rightspacer {\n  width: 40px;\n  flex: 0 0 40px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
